import type { ExcelReport, ExcelTable } from "./excelReports";

export const EXCEL_LICENSE_URL = "https://estada.de/shop";
export const EXCEL_LICENSE_NOTICE = "Das Dokument dient nur der Ansicht.\nDie ESTADA App hat keine Lizenz.\nHole dir jetzt eine Lizenz: estada.de/shop";

/** Removes restricted data before serialization; every middle group retains at most three detail rows. */
export function createExcelLicensePreview(report: ExcelReport): ExcelReport {
  const reduceTable = (table: ExcelTable): ExcelTable => {
    const output: ExcelTable = { ...table, rows: [], rowLevels: [], rowMerges: [], smallTextRows: [], topAlignedRows: [], licenseNoticeRows: [], blockEndRows: [] };
    let count = 0;
    let group = false;
    let noticeAdded = false;
    const notice = () => {
      if (noticeAdded) return;
      output.rows.push([EXCEL_LICENSE_NOTICE, ...table.columns.slice(1).map(() => "")]);
      output.rowLevels!.push(table.rowLevels ? 3 : 0);
      output.rowMerges!.push([[0, table.columns.length - 1]]);
      output.smallTextRows!.push(false);
      output.topAlignedRows!.push(false);
      output.licenseNoticeRows!.push(true);
      output.blockEndRows!.push(false);
      noticeAdded = true;
    };
    for (const [index, row] of table.rows.entries()) {
      const level = table.rowLevels?.[index];
      if (level === 1 || level === 2) {
        if (group) notice();
        count = 0;
        noticeAdded = false;
        group = level === 2;
      } else if (count >= 3) { notice(); continue; }
      else count++;
      output.rows.push(row);
      output.rowLevels!.push(level ?? 0);
      output.rowMerges!.push(table.rowMerges?.[index] ?? []);
      output.smallTextRows!.push(table.smallTextRows?.[index] ?? false);
      output.topAlignedRows!.push(table.topAlignedRows?.[index] ?? false);
      output.licenseNoticeRows!.push(false);
      output.blockEndRows!.push(table.blockEndRows?.[index] ?? false);
    }
    notice();
    // Tables without hierarchy should retain their usual row styling and lack outline groups.
    if (!table.rowLevels) delete output.rowLevels;
    return output;
  };
  const sections = report.sections.length ? report.sections : [{ title: "Keine Einträge vorhanden", tables: [] }];
  return { ...report, sections: sections.map(section => ({ ...section, tables: (section.tables.length ? section.tables : [{
    columns: Array.from({ length: report.columnWidths?.length ?? 3 }, () => ""), rows: [],
  }]).map(reduceTable) })) };
}
